import React from "react";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import TotalGuestTimePresenter from "./TotalGuestTimePresenter";
import withRouter from "../../../withRouter";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import { Progress } from "../../../nq-component";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import GuestCountsByTimeReport from "./components/GuestCountsByTimeReport";
import { exportGuestCountsByHourCSV } from "./utils/guestCountsByHourCsvUtils";
import ProgressLoader from "../../../components/ProgressLoader";
import DateRangeReport from "../../../components/DateRangeReport";
import PageHeader from "../../../components/PageHeader";
import CustomSelect from "../../../components/CustomSelect";
import { addDays, addHours, addMinutes, format, startOfDay } from "date-fns";

class TotalGuestTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalGuestTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );
    return [...new Set(storeCodes)];
  }

  handleDateChange(event) {
    const selectedDate = event.target.value;
    const formattedDate = this.formatDate(selectedDate);
    this.setState({ selectedDate: event.target.value });
    this.presenter.onChangeDate(formattedDate);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    const startTime = new Date(date);
    startTime.setHours(5, 0, 0, 0);
    const formattedStartTime = this.formatDateToCustom(startTime);

    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1); // Move to the next day
    endTime.setHours(4, 59, 0, 0);
    const formattedEndTime = this.formatDateToCustom(endTime);

    return {
      tran_date: {
        $gte: formattedStartTime,
        $lte: formattedEndTime,
      },
    };
  }

  formatDateToCustom(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  // filterTransactions(transactions) {
  //   console.log("TTTT", transactions);
  //   const selectedDate = new Date(this.state.selectedDate);
  //   selectedDate.setHours(0, 0, 0, 0);

  //   return transactions
  //     .filter((obj) => obj.status === "C")
  //     .filter((transaction) => {
  //       const transactionDate = new Date(transaction.tran_date);
  //       transactionDate.setHours(0, 0, 0, 0);

  //       const selectedDateMatch =
  //         transactionDate.getTime() === selectedDate.getTime();
  //       const storeCodeMatch = this.state.selectedStoreCode
  //         ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
  //           this.state.selectedStoreCode
  //         : true;

  //       return selectedDateMatch && storeCodeMatch;
  //     });
  // }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(0, 0, 0, 0);

    const startDate = addHours(startOfDay(selectedDate), 5);
    const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);

    const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
    const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

    console.log("Selected Date Range: ", {
      $gte: formattedStartDate,
      $lte: formattedEndDate,
    });

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const transactionDateMatch =
          transactionDate >= startDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        // return transactionDateMatch && storeCodeMatch;
        return true;
      });
  }

  countTransactionTypesPerHour = (transactions) => {
    const counts = {
      solo: new Array(24).fill(0),
      couple: new Array(24).fill(0),
      smallGroup: new Array(24).fill(0),
      meduimGroup: new Array(24).fill(0),
      largeGroup: new Array(24).fill(0),
    };

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const filteredTransactions = transactions.filter((transaction) => {
      const transactionDate = new Date(transaction.createdAt);
      return transactionDate;
    });

    // Count transactions per type for each hour
    filteredTransactions.forEach((transaction) => {
      console.log("transaction", transaction);
      const hour = new Date(transaction.tran_date).getHours();
      const index = hour < 5 ? hour + 19 : hour - 5;
      switch (transaction.cust_count) {
        case "1":
          counts.solo[index]++;
          break;
        case "2":
          counts.couple[index]++;
          break;
        case "3":
        case "4":
        case "5":
          counts.smallGroup[index]++;
          break;
        case "6":
        case "7":
        case "8":
        case "9":
        case "10":
          counts.meduimGroup[index]++;
          break;
        case "11":
        case "12":
        case "13":
        case "14":
        case "15":
          counts.largeGroup[index]++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  getChartData() {
    const filteredTransactions = this.filterTransactions(this.state.objects);
    const newCounts = this.countTransactionTypesPerHour(filteredTransactions);
    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });

    return {
      labels,
      datasets: [
        { label: "Solo (1)", data: newCounts.solo },
        { label: "Couple (2)", data: newCounts.couple },
        { label: "Small Group (3-5)", data: newCounts.smallGroup },
        { label: "Medium Group (6-10)", data: newCounts.meduimGroup },
        { label: "Large Group (11-15)", data: newCounts.largeGroup },
      ],
    };
  }

  getHighchartsOptions(chartData) {
    return {
      chart: { type: "areaspline" },
      title: { text: null },
      xAxis: {
        categories: chartData.labels,
        crosshair: true,
        title: { text: "Time of Day" },
      },
      yAxis: {
        min: 0,
        title: { text: "Guest Count" },
        stackLabels: { enabled: true },
      },
      tooltip: {
        shared: true,
        headerFormat: "<b>{point.x}</b><br/>",
        pointFormat: "{series.name}: {point.y}<br/>",
        footerFormat: "Total: {point.total}",
      },
      plotOptions: {
        areaspline: {
          stacking: "normal",
          fillOpacity: 0.4,
          marker: { enabled: false },
        },
      },
      series: [
        { name: "Solo (1)", data: chartData.datasets[0].data, color: "#1b74bb" },
        { name: "Couple (2)", data: chartData.datasets[1].data, color: "#ffcd56" },
        {
          name: "Small Group (3-5)",
          data: chartData.datasets[2].data,
          color: "#4bc0c0",
        },
        {
          name: "Medium Group (6-10)",
          data: chartData.datasets[3].data,
          color: "#344054",
        },
        {
          name: "Large Group (11-15)",
          data: chartData.datasets[4].data,
          color: "#d0d5dd",
        },
      ],
      credits: { enabled: false },
    };
  }
  exportToCSV = () => {
    const { objects } = this.state;
    const filtered = this.filterTransactions(objects);
    const countTransaction = this.countTransactionTypesPerHour(filtered);
    const range = this.state.range;
    exportGuestCountsByHourCSV(filtered, countTransaction, range);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, selectedDate, storess } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getHighchartsOptions(chartData);
    const chartId = "chart-container14";
    const storeOptions = [
      { value: "AllStore", label: "All Store" },
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode,
    );
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Total Guest vs. Time of Day"
            subtitle="Guest count distribution by time of day"
            icon="bi bi-clock-history"
          />
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              error={
                !this.state.range ? "Please select a date range first" : ""
              }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <GuestCountsByTimeReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            range={this.state.range}
            chartRef={this.chartRef14}
            containerId="chart-container14"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TotalGuestTimePage);
